export default {
  closeAll: "Fechar todos",
  comment: "Comentário",
  edit: "Editar",
  expandAll: "Expandir todos",
  howDoYouRateThisService: "Como você avalia este atendimento",
  imDissatisfied: "Estou insatisfeito",
  imSatisfied: "Estou satisfeito",
  knowWhatYouThink: "Queremos saber o que você achou",
  loading: "Carregando...",
  neutral: "Neutro",
  next: "Próxima",
  no: "Não",
  openedIn: "Aberto em",
  owner: "Responsável",
  pageNotFound: "Página não encontrada",
  ratingOf: "Avaliação de {{name}}",
  requester: "Solicitante",
  satisfied: "Bom",
  saveComment: "Salvar comentário",
  send: "Enviar",
  service: "Serviço",
  thanks: "Muito obrigado",
  ticketSummary: "Resumo do ticket",
  unsatisfied: "Ruim",
  verySatisfied: "Ótimo",
  veryUnsatisfied: "Péssimo",
  withYourFeedbackWeCanImproveRelationship:
    "Com o seu feedback podemos sempre melhorar a nossa relação",
  yes: "Sim",
  yourOpinionWorthALot: "Sua opinião é muito importante para nós",
  yourRatingHasAlreadyBeenSaved:
    "A sua avaliação para nosso atendimento já foi salva."
};
